window.onload = function() {
        const $ = document.querySelector.bind(document);
        const $$ = document.querySelectorAll.bind(document);

        const tabs = $$('.tab-item');
        const panes = $$('.tab-pane');

        const tabActive = $('.tab-item.active')
        const line = $('.tabs .line');

        function tabLine(t) {
            line.style.left = t.offsetLeft + 'px';
            line.style.width = t.offsetWidth + 'px';
        }
        // tabLine(tabActive);
        tabs.forEach((tab, index) => {
            const pane = panes[index];
            tab.onclick = function () {
                $('.tab-pane.active').classList.remove('active');
                $('.tab-item.active').classList.remove('active');

                // tabLine(this)

                pane.classList.add('active');
                this.classList.add('active')
            }
        })
}